import { Util } from 'src/shared/util/util';
import { Component, ViewChild, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { WindowService } from 'src/shared/providers/window.service';
import { Capacitor } from '@capacitor/core';

import { Booking } from 'src/providers/booking/booking';
import { BookJob } from 'src/providers/book-job/book-job';
import { Client } from 'src/providers/client/client';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { Communication } from 'src/providers/communication/communication';
import { DynamicComponentProvider } from 'src/shared/providers/dynamic-component/dynamic-component';
import { Logger } from 'src/providers/logger';
import { Me } from 'src/providers/me/me';
import { Pros } from 'src/providers/pros/pros';
import { Schedule } from 'src/providers/schedule/schedule';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { ToDos } from 'src/providers/to-dos/to-dos';
import { GuestReservations } from 'src/providers/guest-reservations/guest-reservations';

import { Loading } from 'src/shared/components/loading/loading';
import { ConfirmPage, ConfirmPageParamsModel } from 'src/pages/confirm/confirm.component';

import { ClientSettingsModel } from 'src/models/client.model';

import { MapPopup } from 'src/pages/dashboard/map-popup/map-popup';
import { popupOptions } from 'src/pages/dashboard/map-popup/popup-opts';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { RequestJobPage } from 'src/pages/request-job/request-job';
import { BookService } from 'src/shared/services/book.service';
import { ProDidNotShowUpPage } from 'src/pages/pro-did-not-show-up/pro-did-not-show-up';
import { NotificationDetailPage } from '../notification-details/notification-details';
import { MyProPage } from 'src/pages/my-pros/my-pro/my-pro';
import { RequestSubstitutePage } from 'src/pages/request-substitute/request-substitute';
import { JobBackupTimesPage } from 'src/pages/job-backup-times/job-backup-times';
import { ShareJobPage } from 'src/pages/share-job/share-job';
import { MarkJobCompletePage } from '../mark-job-complete/mark-job-complete';

import { MessageThreadPage } from 'src/pages/messages/message-thread/message-thread';
declare const mapboxgl: any;
import { DateTime as LuxonDateTime } from 'luxon';
import { lastValueFrom, Subscription } from 'rxjs';
import { RescheduleCancelPage } from 'src/pages/reschedule-cancel/reschedule-cancel';
import { SelectCategoryPage } from 'src/pages/select-category/select-category';
import { ReportIssue } from 'src/providers/report-issue/report-issue';
import { TasksService } from 'src/providers/tasks/tasks';
import { Integrations } from 'src/providers/integrations/integrations';
import { TranslationPipe } from 'src/shared/pipes/translation.pipe';
import { ParseDateTimePipe } from 'src/shared/pipes/parse-date.pipe';
import { TaskDropdownComponent } from 'src/shared/components/task-dropdown/task-dropdown';
import { ConciergeApiService } from 'src/shared/services/concierge-api.service';
import { RestockingOrdersService, RestockTask, restockTaskFromApi } from 'src/shared/services/restocking-orders.service';
import { stateLabel } from 'src/shared/services/restock-order-state.pipe';
import { ThemeService } from 'src/shared/services/theme.service';
import { DemoBlockService } from 'src/shared/services/demo-block.service';
import { DisputeResolutionPage } from 'src/pages/concierge/dispute-resolution/dispute-resolution';
import { ConciergeItemModel } from 'src/models/concierge.model';

// Route params and localStorage hand ids over as strings, and a missing one used
// to turn into NaN and reach the API as `booking-details/NaN`.
const toId = (value: unknown): number | null => {
  const id = Number(value);
  return Number.isInteger(id) && id > 0 ? id : null;
};

@Component({
    templateUrl: 'job.html',
    standalone: false
})

export class JobPage implements OnInit, OnDestroy {

  addressName: string;
  bookingFormAnswers: any;
  clientName: string;
  jobBackPage: string;
  jobBackupTimes: any;
  jobBackupTimesCount: number;
  jobBackupTimesLoaded: boolean;
  jobId: number;
  addressId: any;
  hasPrivatePro: boolean;
  notificationHistory: any;
  isLoadingNotificationHistory = false;
  settings: ClientSettingsModel;
  mapInstance: any;
  @ViewChild('map', {static: false}) mapElement: ElementRef;
  @ViewChild('maintenanceDropdown') maintenanceDropdown: TaskDropdownComponent;
  dialogParams: any;
  isRightSideContent = true;
  isMapLoaded = false;
  jobEvents: any[];
  smallestQuote = 0;
  potentialHomekeeper: any;
  jobDropdownMenu: { label: string; action: string }[] = [];
  private dropDownMenuSubscription: Subscription;
  isNativeMobile = Capacitor.isNativePlatform();
  pendingDispute: ConciergeItemModel | null = null;
  pendingDisputeTitle = '';
  pendingDisputeBody = '';
  booking: any;
  customFields: any[] = [];
  pros: any[] = [];
  isProsLoaded = false;
  isInstructionsLoaded = false;
  showProSearchAgentHistory: boolean;
  bookingId: number;
  loadErrorMessage: string | null = null;
  isSearchingForPro: boolean;
  requestedSearchTimes: string[] = [];
  waterfallIndex = 0;
  checklistItems: any[] = [];
  cancellationReasons: { firstName: string; reason: string }[] = [];
  isHKReportedClientCancelation = false;
  isCantAccessHome = false;
  isConfirmedCantAccessHome = false;
  hasCurrentIssue = false;

  // Restock orders the customer has attached to this job so the pro restocks
  // them (card gCUZuCjf). `restockTasks` comes from the booking-details payload;
  // `assignableOrderOptions` are the address's ordered/delivered orders not yet
  // attached to this job.
  restockTasks: RestockTask[] = [];
  assignableOrderOptions: { id: number; title: string; subtitle: string; statusLabel: string; statusClass: string }[] = [];
  showRestockPicker = false;

  boundUpdateRequestedTimes = this.updateRequestedTimes.bind(this);
  boundRescheduleJob = this.rescheduleJob.bind(this);
  boundCancelJob = this.skipJob.bind(this);
  boundCallPro = this.callPro.bind(this);
  boundKeepOnePro = this.keepOnlyOnePro.bind(this);
  boundSaveRestockNote = this.saveRestockNote.bind(this);

  parsedQuotes: any[] = [];
  selectedQuoteId: any = null;
  showQuotesLeftArrow = false;
  showQuotesRightArrow = false;
  @ViewChild('quotesScrollContainer') quotesScrollContainer: ElementRef;
  private quotesScrollListener: (() => void) | null = null;

  get selectedQuote() {
    return this.parsedQuotes.find(q => q.id === this.selectedQuoteId);
  }

  selectQuote(id: any) {
    this.selectedQuoteId = id;
  }

  scrollQuotesLeft() {
    const el = this.quotesScrollContainer?.nativeElement;
    if (!el) {return;}
    el.scrollBy({ left: -300, behavior: 'smooth' });
  }

  scrollQuotesRight() {
    const el = this.quotesScrollContainer?.nativeElement;
    if (!el) {return;}
    el.scrollBy({ left: 300, behavior: 'smooth' });
  }

  updateQuotesArrows() {
    const el = this.quotesScrollContainer?.nativeElement;
    if (!el) {return;}
    this.showQuotesLeftArrow = el.scrollLeft > 0;
    this.showQuotesRightArrow = el.scrollLeft + el.clientWidth < el.scrollWidth - 1;
  }

  private initQuotesScrollListener() {
    setTimeout(() => {
      const el = this.quotesScrollContainer?.nativeElement;
      if (!el) {return;}
      this.quotesScrollListener = () => this.updateQuotesArrows();
      el.addEventListener('scroll', this.quotesScrollListener, { passive: true });
      this.updateQuotesArrows();
    }, 100);
  }

  constructor(
    private bookJobService: BookJob,
    private client: Client,
    public communication: Communication,
    private dynamicComponentService: DynamicComponentProvider,
    private logger: Logger,
    public me: Me,
    private modalCtrl: ModalController,
    private navCtrl: CustomNavController,
    private prosService: Pros,
    private route: ActivatedRoute,
    public schedule: Schedule,
    private storage: TidyStorage,
    public toDosProvider: ToDos,
    private util: Util,
    private rightSidePanelService: RightSidePanelService,
    public windowService: WindowService,
    private guestReservations: GuestReservations,
    private reportIssue: ReportIssue,
    public tasksService: TasksService,
    private integrations: Integrations,
    private bookService: BookService,
    private conciergeApi: ConciergeApiService,
    private bookingProvider: Booking,
    private restockingOrders: RestockingOrdersService,
    public themeService: ThemeService,
    private demoBlock: DemoBlockService
  ) {
    this.rightSidePanelService.setDialogPageTitle('Job');
    this.tasksService.tasksLoaded = false;
    this.bookJobService.clearBookJobStorage();
  }

  async ngOnInit() {
    await this.loadParams();
    if (!this.bookingId) {
      await this.resolveBookingFromJob();
    }
    if (!this.bookingId) {
      this.loadErrorMessage = "We couldn't load this job. Please go back and open it again.";
      return;
    }
    try {
      this.booking = await this.schedule.getBooking(this.bookingId);
    } catch (_err) {
      this.loadErrorMessage = "We couldn't load this job. Please go back and open it again.";
      return;
    }
    this.parseBookingInfo();
    this.jobId = this.booking.booking.current_job.id;
    this.setAddressId(this.addressId || this.booking.address?.id);
    this.addressName = this.client.buildAddressName(this.booking.address);
    this.buildMenuDropdown();
    this.loadBackgroundData();
  }

  parseBookingInfo() {
    if (this.booking.waterfall_notification_history) {
      this.waterfallIndex = this.booking.waterfall_notification_history.findIndex(
        (entry) => entry.waterfall_notification_history?.length > 0
      );
      if (this.waterfallIndex === -1) {
        this.waterfallIndex = 0;
      }
      this.booking.waterfall_notification_history[this.waterfallIndex].waterfall_notification_history = this.schedule.getFilteredWaterfallHistory(this.booking.waterfall_notification_history[this.waterfallIndex].waterfall_notification_history);
    }
    this.isSearchingForPro = this.booking.substitute_search?.status === 'initiated' || this.booking.job_request_status === 'pending';
    this.parseCancellationReasons();
    this.parseRequestedSearchTimes();
    this.parseCurrentIssue();
    this.parseRestockTasks();
  }

  // Restock tasks arrive nested in the booking-details payload; a job can have
  // several attached orders. See card gCUZuCjf.
  parseRestockTasks() {
    this.restockTasks = (this.booking?.restock_tasks || []).map(restockTaskFromApi);
  }

  parseRequestedSearchTimes() {
    this.requestedSearchTimes = [];
    // Job requests already show their window in the header, so this is substitute-only.
    if (this.booking?.job_request_status) {
      return;
    }
    // The customer's pending substitute request wins over the booking backup times.
    const requestedTimes = this.booking?.substitute_search?.requested_times || [];
    const selectedBackupTimes = (this.booking?.substitute_search?.backup_times || [])
      .filter((time) => time?.selected);
    const backupTimes = (requestedTimes.length ? requestedTimes : selectedBackupTimes)
      .sort((a, b) => `${a.date} ${a.start_time}`.localeCompare(`${b.date} ${b.start_time}`));
    if (backupTimes.length) {
      const timesByDate = new Map<string, string[]>();
      backupTimes.forEach((time) => {
        const formattedTimes = timesByDate.get(time.date) || [];
        const formattedTime = this.formatSearchTime(time.start_time);
        if (!formattedTimes.includes(formattedTime)) {
          formattedTimes.push(formattedTime);
        }
        timesByDate.set(time.date, formattedTimes);
      });
      this.requestedSearchTimes = Array.from(timesByDate.entries()).map(([date, times]) =>
        `${new ParseDateTimePipe().transform(date, 'dddd')} ${times.join(', ')}`
      );
    } else {
      // No backup times were set, so the search only covered the original cleaning time.
      const startDatetimeLocal = this.booking?.booking?.current_job?.start_datetime_local;
      if (startDatetimeLocal) {
        const startDateTime = LuxonDateTime.fromISO(startDatetimeLocal, { setZone: true });
        this.requestedSearchTimes = [
          `${new ParseDateTimePipe().transform(startDatetimeLocal, 'dddd')} ${this.formatSearchTime(startDateTime.toFormat('HH:mm'))}`
        ];
      }
    }
  }

  private formatSearchTime(time: string): string {
    const dateTime = LuxonDateTime.fromFormat(time, 'HH:mm');
    return dateTime.toFormat(dateTime.minute === 0 ? 'ha' : 'h:mma').toLowerCase();
  }

  parseCurrentIssue() {
    const currentIssue = this.booking?.current_issue;
    const alreadyHandled = localStorage.getItem(`handled_cancellation_${this.bookingId}`) === 'true';
    this.isHKReportedClientCancelation = currentIssue === 'HK Reported Client Cancelation' && !alreadyHandled;
    this.isCantAccessHome = currentIssue === "Can't Access Home";
    this.isConfirmedCantAccessHome = currentIssue === "Confirmed Can't Access Home";
    this.hasCurrentIssue = this.isHKReportedClientCancelation || this.isCantAccessHome || this.isConfirmedCantAccessHome;
  }

  parseCancellationReasons() {
    this.cancellationReasons = [];
    const allEmpty = this.booking?.waterfall_notification_history?.every(
      (entry) => !entry.waterfall_notification_history?.length
    );
    if (allEmpty && this.booking?.previously_assigned_pros?.length) {
      for (const entry of this.booking.previously_assigned_pros) {
        for (const reason of (entry.unassignment_reasons || [])) {
          if (reason.homekeeper?.first_name && reason.cancellation_reason) {
            this.cancellationReasons.push({
              firstName: reason.homekeeper.first_name,
              reason: reason.cancellation_reason
            });
          }
        }
      }
    }
  }

  ngOnDestroy() {
    if (this.dropDownMenuSubscription) {
      this.dropDownMenuSubscription.unsubscribe();
    }
    this.rightSidePanelService.clearHeaderDropdownMenu();
    if (this.quotesScrollListener && this.quotesScrollContainer?.nativeElement) {
      this.quotesScrollContainer.nativeElement.removeEventListener('scroll', this.quotesScrollListener);
    }
  }

  ionViewDidLeave() {
    this.mapInstance?.remove();
  }

  buildMenuDropdown(): void {
    const items: { label: string; action: string }[] = [
      { label: 'Reschedule', action: 'job-goToRescheduleJob' },
      { label: 'Cancel', action: 'job-goToCancelJob' },
    ];
    if (this.booking?.booking?.current_job?.is_private) {
      items.push({ label: 'Mark Job as Complete', action: 'job-goToMarkJobComplete' });
    }
    items.push({ label: 'Share', action: 'job-goToShareJobPage' });
    this.jobDropdownMenu = items;
    if (this.isRightSideContent) {
      this.rightSidePanelService.setHeaderDropdownMenu(items);
    }
    this.dropDownMenuSubscription = this.rightSidePanelService.dropDownMenuAction$.subscribe((action) => {
      this.runMenuAction(action);
    });
  }

  async loadParams() {
    try {
      this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
      this.dialogParams = await this.storage.retrieve('dialog-params');
      let navParams = null;
      try { navParams = this.navCtrl.getParams(false); } catch (_e) { /* nav params unavailable */ }
      const params = this.windowService.isDesktopRes
        ? (this.dialogParams || navParams)
        : (navParams || this.dialogParams);
      this.displayAvailableDataImmediately(params);
      const job = this.windowService.isDesktopRes ? this.dialogParams?.object : params?.object;
      this.setAddressId(job?.address_id || this.dialogParams?.addressId || this.route.snapshot.paramMap.get('addressId'));
      this.addressName = this.client.buildAddressName(params?.address || '');
      const shouldShowAllToDosPage = localStorage.getItem('shouldShowAllToDosPage') === 'true';
      this.jobBackPage = localStorage.getItem('jobBackPage') || (shouldShowAllToDosPage || this.windowService.isDesktopRes ? 'schedule' : 'schedule-list');
      this.bookingId = toId(job?.booking?.id || job?.booking_id || params?.bookingId || params?.card?.template_data?.booking?.id || localStorage.getItem('bookingId'));
      localStorage.removeItem('bookingId');
      this.jobId = toId(params?.jobId || this.route.snapshot.paramMap.get('jobId'));
      this.checkForPendingDispute();
    } catch (err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message, 10000);
    }
  }

  // A refresh or a direct /job/:addressId/:jobId link carries no booking id, so
  // the job card is the only place left to find it.
  private async resolveBookingFromJob() {
    if (!this.jobId) {
      return;
    }
    try {
      const card = await this.schedule.getJobDetail(this.jobId);
      this.bookingId = toId(card?.booking?.id);
      this.setAddressId(this.addressId || card?.job?.address_id || card?.address?.id);
    } catch (_err) {
      this.bookingId = null;
    }
  }

  // Other pages (book-job, pros) read the current address from localStorage, so
  // a missing id must never be stored there as "NaN".
  private setAddressId(addressId) {
    this.addressId = toId(addressId);
    if (this.addressId) {
      localStorage.setItem('addressId', String(this.addressId));
    }
  }

  displayAvailableDataImmediately(params) {
    const bookingObject = params?.object?.booking;
    if (bookingObject) {
      this.booking = {
        booking: {
          id: bookingObject?.id,
          start_date_no_earlier_than: this.convertBookingDates(bookingObject?.start_date_no_earlier_than || ''),
          start_time_no_earlier_than: this.convertBookingTimes(bookingObject?.start_time_no_earlier_than || ''),
          end_date_no_later_than: this.convertBookingDates(bookingObject?.end_date_no_later_than || ''),
          end_time_no_later_than: this.convertBookingTimes(bookingObject?.end_time_no_later_than || ''),
        },
        service_type_details: {},
      }
      if (this.windowService.isDesktopRes) {
        this.booking.booking['current_job'] = { start_datetime_local: this.getBookingDate(bookingObject?.start_date_no_earlier_than || '', bookingObject?.start_time_no_earlier_than || '') };
      }
    }
  }

  private async loadBackgroundData() {
    this.loadProsArray();
    this.parseQuotes();
    this.loadCustomFields();
    this.loadClientName();
    this.loadJobBackupTimes();
    this.loadBookingFormAnswers();
    this.loadJobEvents(this.bookingId);
    this.loadClientSettings();
    this.checkIfHasPrivatePro();
    this.buildMap();
    this.loadAssignableRestockOrders();
    this.checklistItems = await this.toDosProvider.getAllToDoListItems("Don't Use Checklists");
  }

  // The address's ordered/delivered restock orders not already attached to this
  // job — the pool the "Add Restocking Task" picker offers. Non-blocking: a
  // failure just means the pill won't offer anything.
  private async loadAssignableRestockOrders() {
    if (!this.addressId) {
      this.assignableOrderOptions = [];
      return;
    }
    try {
      const orders = await this.restockingOrders.loadOrders(this.addressId);
      const attachedIds = new Set(
        this.restockTasks.filter((task) => task.state === 'pending').map((task) => task.id)
      );
      this.assignableOrderOptions = orders
        .filter((order) => (order.state === 'ordered' || order.state === 'delivered') && !attachedIds.has(order.id))
        .map((order) => {
          const itemCount = order.items?.length || 0;
          return {
            id: order.id,
            title: `Order #${order.id}`,
            subtitle: `${itemCount} ${itemCount === 1 ? 'item' : 'items'}`,
            statusLabel: stateLabel(order.state),
            statusClass: order.state,
          };
        });
    } catch {
      this.assignableOrderOptions = [];
    }
  }

  openRestockPicker() {
    this.showRestockPicker = true;
  }

  closeRestockPicker() {
    this.showRestockPicker = false;
  }

  // Attach an order to this booking, then refresh the booking-details payload so
  // the new restock task (and updated assignable pool) render.
  async assignRestockOrder(orderId: number) {
    try {
      await this.restockingOrders.assignBooking(orderId, this.booking.booking.id);
      this.showRestockPicker = false;
      await this.refreshRestockData();
      this.util.showSuccess('Restocking task added to this job.');
    } catch (error) {
      this.util.showError(error?.message || 'Could not add the restocking task.');
    }
  }

  async unassignRestockOrder(orderId: number) {
    try {
      await this.restockingOrders.unassignBooking(orderId, this.booking.booking.id);
      await this.refreshRestockData();
    } catch (error) {
      this.util.showError(error?.message || 'Could not remove the restocking task.');
    }
  }

  async saveRestockNote(event: { orderId: number; note: string }) {
    try {
      await this.restockingOrders.updateProNote(event.orderId, event.note);
      await this.refreshRestockData();
    } catch (error) {
      this.util.showError(error?.message || 'Could not save the note.');
      throw error;
    }
  }

  // Re-pull the booking (restock_tasks live there) and rebuild the assignable pool.
  private async refreshRestockData() {
    this.booking = await this.schedule.getBooking(this.bookingId);
    this.parseRestockTasks();
    await this.loadAssignableRestockOrders();
  }

  async parseQuotes() {
    const potentialHomekeepers = this.booking?.quotes?.quotes || [];
    if (!this.potentialHomekeeper) {
      const acceptedHomekeeperStatuses = ['accepted_by_customer', 'accepted_by_both', 'declined_by_homekeeper'];
      const potentialHomekeeper = potentialHomekeepers?.find((homekeeper) =>
        homekeeper.rates?.some((rate: any) =>
          rate.times?.some((time: any) =>
            acceptedHomekeeperStatuses.includes(time.status)
          )
        )
      );
      if (potentialHomekeeper) {
        this.potentialHomekeeper = {
          ...potentialHomekeeper,
          name: `${potentialHomekeeper.first_name} ${potentialHomekeeper.last_name}`
        };
      }
    }
    // Calculate smallest quote from new rates structure (time-level amounts)
    const allAmounts: number[] = [];
    potentialHomekeepers?.forEach((homekeeper) => {
      if (homekeeper?.rates && Array.isArray(homekeeper.rates)) {
        homekeeper.rates.forEach((rate: any) => {
          if (rate?.times && Array.isArray(rate.times)) {
            rate.times.forEach((timeObj: any) => {
              if (timeObj?.amount !== null && timeObj?.amount !== undefined) {
                allAmounts.push(timeObj.amount);
              }
            });
          }
        });
      } else if (homekeeper?.amount !== null && homekeeper?.amount !== undefined) {
        allAmounts.push(homekeeper.amount);
      }
    });
    this.smallestQuote = allAmounts.length > 0 ? Math.min(...allAmounts) : Infinity;
    if (potentialHomekeepers.length > 0) {
      this.parsedQuotes = this.getParsedQuotesForCarousel(potentialHomekeepers);
      if (this.parsedQuotes.length > 0) {
        this.selectedQuoteId = this.parsedQuotes[0].id;
        this.initQuotesScrollListener();
      }
    }
  }

  private getParsedQuotesForCarousel(potentialHomekeepers: any[]) {
    return potentialHomekeepers.map((quote, quoteIndex) => {
      let dates;
      let singlePrice: number | null = null;

      if (quote.rates && Array.isArray(quote.rates)) {
        dates = quote.rates.map((rate) => {
          const times = rate.times.map((timeObj: any, timeIndex: number) => {
            const timeStr = timeObj.time;
            const [hour, minute] = timeStr.split(':').map(Number);
            const period = hour >= 12 ? 'pm' : 'am';
            const hour12 = hour % 12 || 12;
            const formattedTime = `${hour12}:${minute.toString().padStart(2, '0')}${period}`;
            return {
              viewValue: formattedTime,
              time: timeStr,
              amount: timeObj.amount,
            };
          });
          return { date: rate.date, times };
        });
        const amounts: number[] = [];
        dates.forEach((d) => d.times.forEach((t) => {
          if (t.amount !== null && t.amount !== undefined) {amounts.push(t.amount);}
        }));
        singlePrice = amounts.length > 0 ? Math.min(...amounts) : null;
      } else {
        singlePrice = quote.amount || null;
        dates = [];
      }

      const credentials = quote.credentials || [];
      const displayCredentials = credentials.filter(c => !c.requirement && c.category !== 'core_profile');
      const certifications = displayCredentials.filter(c => c.category === 'certification');
      const links = displayCredentials.filter(c => c.category === 'external_link');
      const profileImageUrl = this.getProfileImageUrl(credentials);
      const pitchDescription = this.getPitchDescription(credentials);
      const yearsExperience = this.getCoreProfileValue(credentials, 'years_experience');
      const teamSize = this.getCoreProfileValue(credentials, 'team_size');
      const isVrhp = this.getCoreProfileValue(credentials, 'vrhp') === 'true';
      const totalJobsCompleted = quote.performance_stats?.total_jobs_completed || null;
      const totalJobsLabel = this.formatJobsCount(totalJobsCompleted);

      return {
        ...quote,
        name: `${quote.first_name} ${quote.last_name}`,
        dates,
        singlePrice,
        displayCredentials,
        certifications,
        links,
        profileImageUrl,
        pitchDescription,
        yearsExperience,
        teamSize,
        isVrhp,
        totalJobsLabel,
      };
    });
  }

  private getProfileImageUrl(credentials: any[]): string | null {
    const cred = credentials?.find(c => c.category === 'core_profile' && c.type === 'profile_image' && c.file_url);
    if (cred?.file_url) {return cred.file_url;}
    const fallback = credentials?.find(c => c.category === 'core_profile' && c.file_url && this.isImageUrl(c.file_url));
    return fallback?.file_url || null;
  }

  private getPitchDescription(credentials: any[]): string | null {
    const cred = credentials?.find(c => c.category === 'core_profile' && c.type !== 'profile_image' && c.type !== 'years_experience' && c.type !== 'team_size' && c.type !== 'vrhp' && c.text_value);
    return cred?.text_value || null;
  }

  private getCoreProfileValue(credentials: any[], type: string): string | null {
    const cred = credentials?.find(c => c.category === 'core_profile' && c.type === type);
    return cred?.text_value || null;
  }

  private formatJobsCount(count: number | null): string | null {
    if (!count) {return null;}
    if (count >= 1000) {
      return `${(count / 1000).toFixed(1).replace(/\.0$/, '')}k Jobs`;
    }
    return `${count} Jobs`;
  }

  openCredentialLink(url: string) {
    this.util.openUrl(url);
  }

  async onQuoteTimeSelected(quote: any, date: string, time: any) {
    const formattedDate = LuxonDateTime.fromISO(date).toFormat('ccc LLL d');
    const priceInCents = time.amount;
    const price = priceInCents % 100 > 0
      ? `$${  (priceInCents / 100).toFixed(2)}`
      : `$${  priceInCents / 100}`;

    const params: ConfirmPageParamsModel = {
      title: `Book with ${  quote.name  }?`,
      body: `Confirm booking on ${formattedDate} at ${time.viewValue} for ${price}. The pro will be notified and your job will be scheduled.`,
      confirmText: 'Accept Quote',
      backText: 'Go Back',
      confirmAction: this.confirmAcceptBid.bind(this, quote, date, time),
    };
    const modal = await this.modalCtrl.create({
      component: ConfirmPage,
      componentProps: params,
      animated: false,
      cssClass: 'confirm-modal',
    });
    await modal.present();
  }

  private async confirmAcceptBid(quote: any, date: string, time: any) {
    try {
      const params = {
        booking_id: this.booking.booking.id,
        homekeeper_id: quote.id,
        amount: time.amount,
        date,
        time: time.time,
        instant_booking: true,
      };
      await this.bookJobService.acceptBid(params);

      if (quote.id && quote.name) {
        try {
          const storedHomekeeperData = await this.storage.retrieve('stored-homekeeper-data') || {};
          storedHomekeeperData[this.jobId] = {
            job_id: this.jobId,
            homekeeper_id: quote.id,
            homekeeper_name: quote.name,
            booking_id: this.booking.booking.id,
          };
          await this.storage.save('stored-homekeeper-data', storedHomekeeperData);
        } catch (storageError) {
          console.error('Error saving homekeeper data to storage:', storageError);
        }
      }

      this.schedule.setReloadSchedulePage();
      this.modalCtrl.dismiss();
      this.booking = await this.schedule.getBooking(this.bookingId);
      this.parseBookingInfo();
      this.loadBackgroundData();
    } catch (error) {
      this.modalCtrl.dismiss();
      const errorMessage = error?.error?.message || error?.message || 'Something went wrong';
      this.util.showError(errorMessage);
    }
  }

  getCredentialIcon(type: string): string {
    const iconMap: Record<string, string> = {
      yelp: 'assets/img/links/yelp.svg',
      facebook: 'assets/img/links/facebook.svg',
      instagram: 'assets/img/links/instagram.svg',
      linkedin: 'assets/img/links/linkedin.svg',
      google: 'assets/img/links/google.svg',
      google_business: 'assets/img/links/google.svg',
      angi: 'assets/img/links/angis-list.svg',
      bbb: 'assets/img/links/bbb.svg',
      personal_website: 'assets/img/links/my-website.svg',
      taskrabbit: 'assets/img/links/taskrabbit.svg',
      thumbtack: 'assets/img/links/thumbtack.svg',
      twitter: 'assets/svg/logo-twitter.svg',
    };
    return iconMap[type] || 'assets/svg/open-outline.svg';
  }

  private isImageUrl(url: string): boolean {
    if (!url) {return false;}
    return /\.(jpg|jpeg|png|gif|webp|svg)(\?|$)/i.test(url) || url.includes('/homekeeper-credentials/');
  }

  goToBidsPage() {
    this.rightSidePanelService.navigateTo('job-request-bids', { booking: this.booking });
  }

  async loadProsArray() {
    const pros = [];
    if (!this.booking?.booking?.current_job?.homekeepers?.length) {
      this.isProsLoaded = true;
      return [];
    }
    const allPros = await this.prosService.getAllPros();
    await Promise.all(this.booking.booking.current_job.homekeepers.map(async homekeeper => {
      let messages = [];
      const pro = allPros.find((hk) => hk.id === homekeeper?.id);
      if (pro) {
        const messagesResponse = await this.communication.getSharedInbox(pro.main_team_id);
        messages = messagesResponse.body;
      }
      pros.push({
        pro: homekeeper,
        numberOfUnreadMessages: messages.filter((message) => !message.is_read).length,
        showMarkNoShowTextValue: !this.booking?.booking?.current_job?.is_private && !this.booking?.current_issue
      });
    }));
    this.pros = pros;
    this.isProsLoaded = true;
  }

  async loadCustomFields() {
    try {
      const userCustomFields = await this.integrations.getCustomFields('Booking');
      const customFields = this.booking?.custom_fields;
      if (!customFields || typeof customFields !== 'object' || Object.keys(customFields).length === 0) {
        this.isInstructionsLoaded = true;
        return [];
      }
      const fields = Object.keys(customFields)
        .map((key) => {
          const userCustomField = userCustomFields.find((field) => field.field_key === key);
          const fieldValue = customFields[key];
          return {
            name: userCustomField?.field_name || key,
            value: fieldValue !== null && fieldValue !== undefined && fieldValue !== '' ? fieldValue : 'N/A',
          };
        })
        .filter(field => field !== null);
      this.customFields = fields;
      this.isInstructionsLoaded = true;
    } catch (_err) {
      this.isInstructionsLoaded = true;
      return [];
    }
  }

  async loadClientName() {
    const me = await this.me.load();
    this.clientName = me.customer_account.name;
  }

  loadJobBackupTimes() {
    this.jobBackupTimesLoaded = false;
    this.jobBackupTimes = this.booking?.substitute_search?.backup_times || [];
    this.jobBackupTimesCount = this.getJobBackupTimesCount();
    this.jobBackupTimesLoaded = true;
  }

  getJobBackupTimesCount() {
    let count = 0;
    this.jobBackupTimes.map((job) => {
      if (job.selected) {
        count += 1;
      }
    });
    return count;
  }

  async loadBookingFormAnswers() {
    this.bookingFormAnswers = await this.schedule.getJobBookingFormAnswers(this.bookingId);
    //calculate getBookingFormSelectValue
    //calcualte getBookingFormMultiselectValue
    if (this.bookingFormAnswers) {
      this.bookingFormAnswers.forEach(answer => {
        if (answer?.template_input?.type === 'select' && answer?.data?.value && typeof answer.data.value === 'object') {
          const keys = Object.keys(answer.data.value);
          answer.selectValue = answer.data.value[keys[0]] || '';
        }
        if (answer?.template_input?.type === 'multiselect' && Array.isArray(answer?.data?.value)) {
          let string = '';
          answer.data.value.map((item, i) => {
            if (item && typeof item === 'object') {
              const keys = Object.keys(item);
              string += item[keys[0]];
            }
            if (i < answer.data.value.length - 1) {
              string += ', ';
            }
          });
          answer.multiselectValue = string;
        }
      });
    }
  }

  async loadJobEvents(bookingId: number) {
    this.jobEvents = await this.schedule.getJobEvents(bookingId);
  }

  async loadClientSettings() {
    const settings = this.navCtrl.getParam('settings');
    this.settings = settings || await this.client.getClientSettings();
  }

  async checkIfHasPrivatePro() {
    const isRentalClient = localStorage.getItem('isRentalClient') === 'true';
    this.hasPrivatePro = isRentalClient || await this.prosService.checkIfHasPrivatePro();
  }

  async buildMap() {
    try {
      if (!this.mapElement) {
        return setTimeout(() => this.buildMap(), 0);
      }
      this.mapInstance = this.createMap();
      setTimeout(() => this.mapInstance.resize(), 100);
      this.isMapLoaded = true;
      const moments = this.getMoments();
      this.addMomentsToMap(moments, this.mapInstance);
      const address = this.booking?.address;
      this.addAddressToMap(this.mapInstance, address);
      this.setMapBounds(this.mapInstance, moments, address);
    } catch (err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message, 10000);
    }
  }

  createMap() {
    mapboxgl.accessToken = 'pk.eyJ1IjoidmljdG9yZmVycmF6IiwiYSI6ImNrdHVoNHc1bTIwYjYycHE1NmhjdzVtdzMifQ.OIqKrdlDh4fJH0g0MO1zLg';
    const map = new mapboxgl.Map({
      container: this.mapElement.nativeElement,
      style: 'mapbox://styles/mapbox/dark-v10',
      zoom: 8,
      maxZoom: 16,
    });
    map.on('style.load', () => {
      const language = localStorage.getItem('language');
      if (language && language !== 'en') {
        map.getStyle().layers.forEach((layer) => {
          if (layer.type === 'symbol' && layer.layout?.['text-field']) {
            map.setLayoutProperty(layer.id, 'text-field', ['coalesce', ['get', `name_${language}`], ['get', 'name']]);
          }
        });
      }
    });
    return map;
  }

  getMoments() {
    const moments: any = [];
    this.booking?.activity_timelines?.map((activityTimeline) => {
      activityTimeline?.activity_timeline_items?.map((moment) => {
        if (moment.type === 'cleaning_update' && moment.data?.latitude) {
          moments.push({
            latitude: moment.data.latitude,
            longitude: moment.data.longitude,
            body: '',
            image: this.schedule.getMomentImage(moment.data.data.type),
            mapIcon: this.schedule.getMomentImage(moment.data.data.type),
            header: moment.data.text
          });
        }
      });
    });
    return [];
  }

  addMomentsToMap(moments, map) {
    moments.forEach((moment, _i) => {
      if (moment?.latitude) {
        const popupContent = this.dynamicComponentService.injectComponent(
          MapPopup, x => x.data = {
            image: moment.image,
            body: moment.body,
            header: moment.header,
            learnMore: ''
          }
        );
        this.createPopupAndMarker(map, popupContent, moment.mapIcon, moment);
      }
    });
  }

  async addAddressToMap(map, address) {
    const popupContent = this.dynamicComponentService.injectComponent(
      MapPopup, x => x.data = {
        image: 'assets/img/house.svg',
        body: '',
        header: address.address_name || address.address1,
        learnMore: ''
      }
    );
    const addressIcon = 'assets/img/map-home-blue.svg';
    this.createPopupAndMarker(map, popupContent, addressIcon, address);
  }

  createPopupAndMarker(map, popupContent, mapIcon, location, customOpts = null) {
    const popup = new mapboxgl.Popup({...popupOptions, ...customOpts}).setDOMContent(popupContent);
    const el = document.createElement('div');
    el.className = 'marker';
    el.innerHTML = `<image src="${mapIcon}" style="width: 40px; height: 40px; padding-top: 10px;"></image>`;
    this.createMarkerInstance({map, el, longLat: [ location.longitude, location.latitude ]}, popup);
  }

  createMarkerInstance(obj, popup) {
    const {el, longLat, map} = obj;
    const marker = new mapboxgl.Marker(el);
    marker.getElement().addEventListener('click', () => {
      const flyToCoords = [...longLat];
      const getZoom = map.getZoom() ;
      const zoomOut = getZoom < 0;
      const lgnSum = zoomOut ? 200 / (5 * getZoom) : 50 / (2 ** getZoom);
      if (flyToCoords[1] + lgnSum > 90) {
        flyToCoords[1] = 90;
      } else if ((flyToCoords[1] + lgnSum < -90)) {
        flyToCoords[1] = -90;
      } else {
        flyToCoords[1] += lgnSum;
      }
      map.flyTo({
        center: flyToCoords
      })
    });
    marker.setLngLat(longLat).setPopup(popup).addTo(map);
  }

  setMapBounds(map, moments, address) {
    const bounds = new mapboxgl.LngLatBounds();
    bounds.extend([address.longitude, address.latitude]);
    moments.forEach((moment) => {
      if (moment.latitude) {
        bounds.extend([moment.longitude, moment.latitude]);
      }
    });
    map.fitBounds(bounds, { padding: 50, duration: 0 });
  }

  private convertBookingDates(date: string): string {
    return LuxonDateTime.fromFormat(date, 'MM/dd/yyyy').toFormat('yyyy-MM-dd');
  }

  private convertBookingTimes(time: string): string {
    return LuxonDateTime.fromFormat(time, "h:mma").toFormat('HH:mm');
  }

  private getBookingDate(date: string, time: string): string {
    return LuxonDateTime.fromFormat(`${date  } ${  time}`, "MM/dd/yyyy h:mma").toISO();
  }

  async checkWaterfallHistory(selectionChange){
    const notification = this.booking?.waterfall_notification_history?.[this.waterfallIndex]?.waterfall_notification_history?.[selectionChange.selectedIndex];
    this.notificationHistory = '';
    this.isLoadingNotificationHistory = true;
    if (notification.type === 'history' && (notification?.data?.id && notification?.data?.unassigned_job_id)){
      try {
        this.notificationHistory = await this.client.getWaterfallNotificationHistory(notification?.data?.id)
      } catch (err) {
        this.util.showError((err.error && err.error.message) ? err.error.message : err.message, 10000);
        this.notificationHistory = '';
        this.logger.error(err);
      }
    } else {
      this.notificationHistory = '';
    }
    this.isLoadingNotificationHistory = false;
  }

  goToNotificationDetailsPage(notification) {
    const params = {
      notification
    }
    const url = 'notification-details';
    const component = NotificationDetailPage;
    this.rightSidePanelService.navigateTo(url, params, component);
  }

  async editWaterfallRequest() {
    const hasPrivatePros = await this.prosService.checkIfHasPrivatePro();
    const isRentalClient = localStorage.getItem('isRentalClient') === 'true';
    if (hasPrivatePros) {
      const params = {
        isRescheduling: true,
        originalJobData: {
          originalBookingId: this.bookingId
        },
        selectedTab: 'request',
        categoryId: this.booking?.service_type_details?.service_category?.id,
        address: this.booking.address,
        date: LuxonDateTime.fromISO(this.booking?.booking?.current_job?.start_datetime_local).toFormat('MM-dd-yyyy')
      }
      await this.bookService.goToBookJob(params);
    } else {
      const serviceTypeDetails = this.booking?.service_type_details;
      const params: any = {
        selectedService: {
          key: serviceTypeDetails?.key,
          title: serviceTypeDetails?.name,
          price: this.booking?.booking?.price,
          duration: serviceTypeDetails?.duration_in_minutes,
        },
        address: this.booking.address,
        planId: this.booking?.booking?.plan_id,
        bookingId: this.bookingId,
        serviceTypeId: this.booking?.service_type_details?.service_category?.id,
      };
      const url = 'request-job';
      const component = RequestJobPage;
      this.rightSidePanelService.navigateTo(url, params, component);
    }
  }

  goToProPage(proId) {
    localStorage.setItem('myProBackPage', `job/${this.addressId}/${this.jobId}`);
    const url = `my-pro/${proId}`;
    const component = MyProPage;
    const params = { proId };
    this.rightSidePanelService.navigateTo(url, params, component);
  }

  goToProSearchAgentSettings() {
    localStorage.setItem('unified_agent_trigger_key', 'custom.pro_search.initiated');
    localStorage.setItem('unified_agent_pro_search_address_id', String(this.addressId));
    if (this.windowService.isDesktopRes) {
      this.navCtrl.navigateForward('agent');
    } else {
      const encodedKey = encodeURIComponent('custom.pro_search.initiated');
      this.navCtrl.navigateForward(`agent/triggers/${encodedKey}`);
    }
  }

  reportNoShow(proName, jobId, hkId) {
    const params = {
      proName,
      hkId,
      jobId
    }
    const url = 'pro-did-not-show-up';
    const component = ProDidNotShowUpPage;
    this.rightSidePanelService.navigateTo(url, params, component);
  }

  requestSubstitute(jobId) {
    const params = {
      jobId,
    };
    const url = `request-substitute/${jobId}`;
    const component = RequestSubstitutePage;
    this.rightSidePanelService.navigateTo(url, params, component);
  }

  goToEditBackupTimes() {
    const params = {
      bookingId: this.bookingId,
      jobBackupTimes: this.jobBackupTimes,
      addressId: this.addressId,
      categoryImage: this.booking?.service_type_details?.service_category?.icon_url,
      serviceName: this.booking?.service_type_details?.name,
      startDatetimeLocal: this.booking?.booking?.current_job?.start_datetime_local,
      addressName: this.addressName,
      params: {
        booking: this.booking,
        addressName: this.addressName,
        settings: this.settings,
        clientName: this.clientName
      }
    }
    const url = 'job-backup-times';
    const component = JobBackupTimesPage;
    this.rightSidePanelService.navigateTo(url, params, component);
  }

  goToShareJobPage() {
    const params = {
      booking: this.booking,
      addressName: this.addressName,
      isPastJobLink: false
    };
    const url = 'share-job';
    const component = ShareJobPage;
    this.rightSidePanelService.navigateTo(url, params, component);
  }

  goToMarkJobComplete() {
    const params = {
      bookingId: this.bookingId,
      jobId: this.jobId,
      price: this.booking?.booking?.price ? (this.booking.booking.price / 100).toString() : null,
      duration: this.booking?.service_type_details?.duration_in_minutes,
    }
    const url = 'mark-job-complete';
    const component = MarkJobCompletePage;
    this.rightSidePanelService.navigateTo(url, params, component);
  }

  openMaintenanceDropdown() {
    if (this.maintenanceDropdown) {
      this.maintenanceDropdown.openDropdown();
    }
  }

  markNoShow(pro) {
    let params;
    const now = new Date();
    const twentyMinAfterStartTime = new Date(this.booking?.booking?.current_job?.start_datetime_local);
    twentyMinAfterStartTime.setMinutes(twentyMinAfterStartTime.getMinutes() + 20);
    const isTooEarly = now < twentyMinAfterStartTime;
    if (isTooEarly) {
      return this.showTooEarlyForNoShow();
    } else {
      params = {
        proName: pro.first_name,
        hkId: pro.id,
        jobId: this.jobId,
        bookingId: this.bookingId
      }
      const url = 'pro-did-not-show-up';
      const component = ProDidNotShowUpPage;
      this.rightSidePanelService.navigateTo(url, params, component);
    }
  }

  async showTooEarlyForNoShow() {
    const alertButtons = [
      {
        text: 'Ok',
        role: 'cancel',
      }
    ]
    const _alert = await this.util.showAlert(
      'Please Wait to Mark No Show',
      'Pros typically ask for a 30 minute buffer for unexpected delays. Please wait until 20 minutes after start time before reporting them as a no show.',
      false,
      alertButtons
    );
  }

  goToMessageThreadPage(pro) {
    const params = {
      backPage: 'messages',
      proId: pro.id
    };
    this.rightSidePanelService.navigateTo('message-thread', params, MessageThreadPage);
  }

  goToRescheduleJob() {
    this.rescheduleJob();
  }

  goToCancelJob() {
    this.skipJob(this.bookingId);
  }

  runMenuAction(action: string): void {
    if (action?.includes('job-')) {
      const methodName = action.replace('job-', '');
      this[methodName]();
    }
  }

  onPopupNoteSaved(booking: any): void {
    this.booking = booking;
  }

  onPopupChecklistSaved(booking: any): void {
    this.booking = booking;
  }

  onPopupCustomFieldSaved(data: {customFields: any[]}): void {
    this.customFields = data.customFields;
  }

  onPopupProChanged(data: {booking: any, jobId: number}): void {
    this.booking = data.booking;
    this.jobId = data.jobId;
    this.loadBackgroundData();
  }

  async keepOnlyOnePro() {
    const params: ConfirmPageParamsModel = {
      title: 'Keep Only 1 Pro?',
      body: 'You\ll be billed the prorated rate.',
      backText: 'Go Back',
      confirmText: 'Confirm',
      confirmAction: this.confirmKeepOnePro.bind(this, this.jobId)
    }
    const confirmationModal = await this.modalCtrl.create({
      component: ConfirmPage,
      componentProps: params,
      animated: false,
      cssClass: 'confirm-modal'
    });
    await confirmationModal.present();
  }

  async confirmKeepOnePro(jobId) {
    try {
      await this.schedule.keepOneProForTwoProJob(jobId);
      const alertButtons = [
        {
          text: 'Ok',
          role: 'cancel',
        }
      ]
      const _alert = await this.util.showAlert(
        'Kept One Pro',
        'You were billed the prorated rate. Please contact the concierge with any questions.',
        false,
        alertButtons
      );
      this.modalCtrl.dismiss();
      this.rightSidePanelService.closeRightSidePanel();
    } catch(err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message, 10000);
      throw err;
    }
  }

  updateRequestedTimes() {
    if (this.booking?.job_request_status) {
      this.editWaterfallRequest();
    } else {
      this.requestSubstitute(this.jobId);
    }
  }

  async rescheduleJob() {
    const address = this.booking?.address;
    const bookingType = this.isHKReportedClientCancelation ? 'add_one_time_job' : 'reschedule_job';
    const jobId = this.jobId;
    const bookingId = this.bookingId;
    const planId = this.booking?.booking?.plan_id;
    const categoryId = this.booking?.service_type_details?.service_category?.id;
    if (this.isHKReportedClientCancelation && bookingId) {
      try {
        await this.schedule.cancelJob(bookingId);
        localStorage.setItem('madeUpdateToSchedule', 'true');
      } catch {
        // Job may already be cancelled, continue to booking
      }
      localStorage.setItem(`handled_cancellation_${bookingId}`, 'true');
    }
    const params = {
      address,
      bookingType,
      jobId,
      bookingId,
      planId,
      categoryId
    }
    const homekeepers = this.booking?.booking?.current_job?.homekeepers;
    if (homekeepers?.length === 1 && homekeepers?.[0]?.id) {
      params['hkId'] = homekeepers[0].id;
      params['filterByPro'] = true;
    }
    params['isRescheduling'] = true;
    const startDateTime = LuxonDateTime.fromISO(this.booking?.booking?.current_job?.start_datetime_local ?? '', { setZone: true });
    params['originalJobData'] = {
      serviceType: this.booking?.service_type_details?.service_category?.id,
      serviceKey: this.booking?.service_type_details?.key,
      originalDate: this.booking?.booking?.current_job?.start_datetime_local,
      originalTime: startDateTime.isValid ? startDateTime.toFormat('HH:mm') : undefined,
      originalPro: homekeepers?.[0]?.id,
      originalAddress: address?.id,
      originalBookingId: bookingId,
      originalPlanId: planId,
      originalJobNotes: this.booking?.booking_notes || []
    };
    await this.storage.save('bookJobBackPage', 'job');
    await this.bookService.goToBookJob(params);
  }

  @Loading('', true)
  async skipJob(bookingId = this.bookingId) {
    if (this.demoBlock.block()) {return;}
    const { reservationId, showAutomaticBookingQuestion, reservationDateTime } = await this.guestReservations.getLastReservationDetails(this.addressId, this.jobId);
    const params: ConfirmPageParamsModel = {
      title: 'Cancel Job?',
      body: 'This will cancel the job (does not affect other jobs).',
      backText: 'Go Back',
      confirmText: 'Cancel Job',
      confirmAction: this.skipJobAction.bind(this, bookingId, showAutomaticBookingQuestion, reservationId),
      showAutomaticBookingQuestion,
      reservationDateTime
    }
    const confirmationModal = await this.modalCtrl.create({
      component: ConfirmPage,
      componentProps: params,
      animated: false,
      cssClass: showAutomaticBookingQuestion ? 'tall-confirm-modal' : 'confirm-modal'
    });
    await confirmationModal.present();
  }

  async skipJobAction(bookingId, showAutomaticBookingQuestion, reservationId) {
    try {
      if (showAutomaticBookingQuestion) {
        const keepAutomaticBookingOn = localStorage.getItem('keepAutomaticBookingOn') === 'true';
        localStorage.removeItem('keepAutomaticBookingOn');
        if (!keepAutomaticBookingOn) {
          await this.guestReservations.toggleAutomaticBookingForReservation(reservationId, false);
        }
      }
      await this.schedule.cancelJob(bookingId);
      localStorage.setItem('madeUpdateToSchedule', 'true');
      localStorage.setItem(`handled_cancellation_${bookingId}`, 'true');
      this.isHKReportedClientCancelation = false;
      const successMessage = 'Job skipped';
      this.util.showSuccess(successMessage);
      this.modalCtrl.dismiss();
      if (this.windowService.isDesktopRes) {
        this.rightSidePanelService.closeRightSidePanel();
      } else {
        const shouldShowAllToDosPage = localStorage.getItem('shouldShowAllToDosPage') === 'true';
        this.navCtrl.navigateForward(shouldShowAllToDosPage ? 'schedule' : 'schedule-list');
      }
    } catch(err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message, 10000);
    }
  }

  getMessageSelectItems() {
    return [
      {
        value: 'is_internal',
        viewValue: new TranslationPipe().transform('Internal note'),
        icon: 'assets/svg/create-outline.svg'
      },
      {
        value: 'public_reply',
        viewValue: new TranslationPipe().transform('Public reply'),
        icon: 'assets/svg/arrow-redo-outline.svg'
      }
    ]
  }

  hasProAssigned(item) {
    return item?.pro?.text !== 'No Pro Found' && item?.pro?.text !== 'Best Available Pro' && item?.pro?.first_name !== 'No Pro Found' && item?.pro?.first_name !== 'Best Available Pro';
  }
  async callPro() {
    const job = this.booking?.booking?.current_job;
    const pro = job?.homekeepers?.[0];
    const phone = job?.is_private
      ? await this.getPrivateProPhone(pro)
      : await this.getProRelayPhone(job?.id, pro?.id);
    if (!phone) {
      return this.util.showError('Error calling pro');
    }
    window.location.href = `tel:${phone}`;
  }

  async getPrivateProPhone(pro) {
    const proDetail: any = await this.prosService.getProDetail(pro?.id, this.addressId).catch(() => null);
    return proDetail?.phone ||
      proDetail?.masked_phone_number ||
      proDetail?.homekeeper?.masked_phone_number ||
      proDetail?.homekeeper?.phone_number ||
      proDetail?.homekeeper?.phone ||
      pro?.phone ||
      pro?.masked_phone_number ||
      pro?.phone_number;
  }

  // Marketplace pros' own numbers are never sent to the client, so we dial the
  // relay number for the job, the same one the Contact Pro page uses.
  async getProRelayPhone(jobId, proId) {
    const contact: any = await this.schedule.getContactData(`cleaning-${jobId}`, this.addressId).catch(() => null);
    const homekeepers = contact?.homekeepers || [];
    const homekeeper = homekeepers.find((hk) => hk.id === proId) || homekeepers[0];
    return homekeeper?.masked_phone_number;
  }

  toggleShowProSearchAgentHistory() {
    this.showProSearchAgentHistory = !this.showProSearchAgentHistory;
  }

  private async checkForPendingDispute(): Promise<void> {
    try {
      const response = await lastValueFrom(
        this.conciergeApi.getConciergeItems('&is_marked_done=false&per_page=20')
      );
      const homekeeperJobIds = this.booking?.booking?.current_job?.homekeepers?.map(hk => hk?.homekeeper_job_id) || [];
      this.pendingDispute = response.body.find(
        item => item.type?.startsWith('dispute.') && homekeeperJobIds.includes(item.metadata?.homekeeper_job_id)
      ) || null;
      if (this.pendingDispute) {
        const actionableTypes = [
          'dispute.customer_dispute_counter_answer',
          'dispute.cleaning.customer.counter_proposal',
          'dispute.cleaning.customer.opened',
        ];
        const pendingTypes = ['dispute.customer_dispute_initiated'];
        if (actionableTypes.includes(this.pendingDispute.type)) {
          this.pendingDisputeTitle = 'Dispute Counter-Proposal';
          this.pendingDisputeBody = 'The pro has made a counter-proposal. Tap to review and accept or reject.';
        } else if (pendingTypes.includes(this.pendingDispute.type)) {
          this.pendingDisputeTitle = 'Dispute Opened';
          this.pendingDisputeBody = 'You opened a dispute for this job. Tap to view details.';
        } else {
          this.pendingDisputeTitle = 'Dispute Resolved';
          this.pendingDisputeBody = 'This dispute has been resolved. Tap to view details.';
        }
      }
    } catch (_err) { /* non-blocking */ }
  }

  goToDisputeResolution(): void {
    const params = { dispute: this.pendingDispute, backPage: `job/${this.addressId}/${this.jobId}` };
    this.rightSidePanelService.navigateTo(
      `dispute-resolution/${this.pendingDispute.id}`, params, DisputeResolutionPage
    );
  }

}
